import React from "react";
import Tick from "@/assets/icon/green-tick.svg";
import { useSelector } from "react-redux";

const TradingSegments = ({ data, onProfileUpdate }) => {
  const isEnabledSegmentModification = useSelector(
    (state: any) => state.featureflag?.hyperverge?.modification?.segment?.isEnabled
  );

  return (
    <div className="tw-mt-4">
      <div className="tw-grid tw-mb-4 tw-grid-cols-4 tw-items-center">
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Equity Cash Trading
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            NSE, BSE
          </div>
        </div>
        {data?.optedForEquitySegment ? (
          <div className="tw-col-span-2 tw-flex tw-items-center tw-gap-1">
            <div>
              <img alt="" src={Tick} />
            </div>
            <div className="tw-text-[12px] tw-text-[#29AD00] tw-font-nmmed">
              Activated
            </div>
          </div>
        ) : (
          isEnabledSegmentModification && (
            <div className="tw-col-span-2">
              <button
                onClick={() => onProfileUpdate("segmentUpdate")}
                className="tw-text-[12px] tw-text-primaryBlack tw-font-nmmed"
              >
                Apply Now
              </button>
            </div>
          )
        )}
      </div>
      <div className="tw-grid tw-grid-cols-4 tw-items-center">
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Derivatives Trading
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            F&O
          </div>
        </div>
        {data?.OptedForDrivativesSegment ? (
          <div className="tw-col-span-2 tw-flex tw-items-center tw-gap-1">
            <div>
              <img alt="" src={Tick} />
            </div>
            <div className="tw-text-[12px] tw-text-[#29AD00] tw-font-nmmed">
              Activated
            </div>
          </div>
        ) : (
          isEnabledSegmentModification && (
            <div className="tw-col-span-2">
              <button className="tw-text-[12px] tw-text-primaryBlack tw-font-nmmed"

              onClick={() => onProfileUpdate("segmentUpdate")}
              >
                Apply Now
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TradingSegments;
